<template>
  <div id="container">
    <div class="margin-10" v-html="cmsArticle.content" />
    <van-dropdown-menu class="margin-tb-10">
      <van-dropdown-item v-model="model.ent_company_id" :options="entCompanies" />
    </van-dropdown-menu>
    <div v-for="salCategory in salCategories" :key="salCategory.id">
      <van-divider content-position="left">{{salCategory.name}}</van-divider>
      <div class="card margin-10" v-for="salProduct in model.sal_products.filter(obj => obj.sal_category_id === salCategory.id)" :key="salProduct.id">
        <van-row>
          <router-link :to="'/sal/product/model?id=' + salProduct.id">
            <van-col span="4">
              <van-image
                width="100%"
                :src="salProduct.thumb.url"
              />
            </van-col>
          </router-link>
          <van-col offset="2" span="12">
            <h4>{{salProduct.name}}</h4>
            <h5>{{salProduct.describe}}</h5>
          </van-col>
         <!--  <van-col span="6" style="padding-top:15px">
            <van-stepper v-model="salProduct.quantity" min="0" />
          </van-col> -->
          <van-col span="6" style="padding-top:22.5px;">
            <van-checkbox style="float:right;padding-right:10px" v-model="salProduct.checked"/>
          </van-col>
        </van-row>
      </div>
    </div>

    <van-form @submit="submit">
<!--       <van-field
        v-model="model.cus_company_name"
        label="公司名称："
        placeholder="请输入"
        maxlength="10"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="model.name"
        label="您的姓名："
        placeholder="请输入"
        maxlength="10"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="model.mobile"
        label="手机号码："
        placeholder="请输入"
        maxlength="11"
        :rules="[{ required: true }]"
      /> -->
      <van-field
        v-model="model.price"
        label="预计充值："
        placeholder="请输入"
        maxlength="11"
        :rules="[{ required: true },{ validator: value => /^[0-9]*$/.test(value) }]"
      />
      <van-field
        v-model="model.remark"
        rows="2"
        autosize
        type="textarea"
        placeholder="备注"
      />
      <div class="margin-10">
        <van-button class="margin-tb-20" round block type="primary" native-type="submit">我选好了</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Api from '@/utils/api'
import wx from 'weixin-js-sdk'

// const token = '0d60e9683b8a11ec88d25e218a50f1ca'

export default {
  created () {
    // var that = this
    Api.post('cms.article/model', {id: '31a917fe3b9011ec88d25e218a50f1ca'}, res => { this.cmsArticle = res.data })
    Api.post('wei.user/model', null, res => {
      this.weiUser = res.data
      this.model.ent_company_id = res.data.cusUser.ent_company_id
    })
    Api.post('sal.category/models', {page: 1, limit: -1, ids: "'6f338a52536611ed886765761f39c11c','c2fc58f4534711edbb5700163e1870b9','c9aa3b92534711edbb5700163e1870b9','d0562510534711edbb5700163e1870b9','78469d6e534911edbb5700163e1870b9','e49c13fd617211edbb5700163e1870b9','f49d5d1a617211edbb5700163e1870b9','fdcf6ba7617211edbb5700163e1870b9'"}, res => {
      this.salCategories = res.data
    })
    Api.post('ent.company/models', {page: 1, limit: -1}, res => {
      let entCompanies = [{text: '请选择门店', value: ''}]
      res.data.forEach(entCompany => {
        entCompanies.push({
          value: entCompany.id,
          text: entCompany.name
        })
      })
      this.entCompanies = entCompanies
    })

    var wishilists = localStorage.getItem('wishilists')
    if (wishilists !== null) {
      wishilists = JSON.parse(wishilists)
      this.model = wishilists
    }

    Api.post('sal.product/models', {page: 1, limit: -1, is_wishlist: 1}, res => {
      if (this.model.sal_products.length === 0 || this.model.sal_products.length !== res.count) {
        this.model.sal_products = res.data.map(obj => { return {id: obj.id, sal_category_id: obj.sal_category_id, quantity: 0, name: obj.name, describe: obj.describe, thumb: obj.thumb} })
      }
    })

    let url = window.location.href
    Api.post('wei.user/jsapi', {url: url}, res => {
      let data = res.data

      wx.config({
        debug: false,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData']
      })
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: '天办行充值送礼活动', // 分享标题
          desc: '年终回馈用户活动，精彩礼品任意选', // 分享描述
          link: 'https://wx.tbxprint.com/wishlist', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://wx.tbxprint.com/static/logo_mini.jpg', // 分享图标
          success: function () {
            // that.$dialog.alert({title: '设置成功', message: '设置成功'})
          }
        })
      })
    })
  },
  data () {
    return {
      weiUser: {},
      model: {
        price: '',
        name: '',
        mobile: '',
        ent_company_id: '',
        sal_products: [],
        remark: ''
      },

      entCompanies: [],
      salCategories: [],
      cmsArticle: {}
    }
  },
  methods: {
    submit () {
      console.log(this.model.sal_products)
      var salProducts = this.model.sal_products.filter(obj => obj.checked === true)
      if (salProducts.length === 0) {
        this.$toast.fail('没有选择商品')
        return false
      }
      if (salProducts.length > 1) {
        this.$toast.fail('只能选择1件商品')
        return false
      }
      // if (this.model.sal_products.filter(obj => obj.quantity > 1).length > 0) {
      //   this.$toast.fail('数量只能为1')
      //   return false
      // }
      if (this.model.ent_company_id === '') {
        this.$toast.fail('请选择所属门店')
        return false
      }
      this.$dialog.confirm({title: '提示', message: '确认提交吗？'})
        .then(() => {
          let params = {}
          params.wor_flow_id = 'a78cb3de4f7211edbb5700163e1870b9'
          params.ent_employee_id = 'a522f07254ec11edbb5700163e1870b9'
          params.ent_company_id = this.weiUser.cusUser.ent_company_id
          params.datas = JSON.stringify({
            cus_user_id: this.weiUser.cusUser.id,
            ent_company_id: this.model.ent_company_id,
            charge1: this.model.price,
            remark: this.model.remark
          })
          params.datarows = JSON.stringify({'5279efab50dd11edbb5700163e1870b9': salProducts.map(obj => { return {sal_product_id: obj.id, quantity: obj.quantity, thumb: obj.thumb} })})
          Api.post('wor.request/create', params, res => {
            this.$router.push({path: '/home'})
          })
        })
    }
  },
  watch: {
    model: {
      handler (val, oldVal) {
        localStorage.setItem('wishilists', JSON.stringify(val))
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Wishlist.vue